<template>
    <C1FormGroup>
        <C1Multiselect
            v-model="attributeOptionsSelected"
            :label="!hideLabel ? (label || localLabel) : ''"
            :label-for="id"
            :placeholder="localInputPlaceholder"
            :options="options"
            :disabled="disabled"
            label-key="value"
            @hit="syncAttributeOption"
        />

        <div
            v-if="attributeOptionsSelected.length"
            class="afu-mt-5"
        >
            <C1Tag
                v-for="attribute in attributeOptionsSelected"
                :key="`${attribute.value}_${attribute.id}`"
                :removable="!disabled"
                @remove="detachAttributeOption(attribute)"
            >
                {{ attribute.value }}
            </C1Tag>
        </div>
    </C1FormGroup>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import C1FormGroup from '@/components/C1Components/C1FormGroup';
    import C1Tag from '@/components/C1Components/C1Tag';
    import C1Multiselect from '@/components/C1Components/C1Multiselect';

    export default {
        name: 'SeekerAttributesDropdown',

        components: { C1Multiselect, C1FormGroup, C1Tag },

        props: {
            label: {
                type: String,
                default: '',
            },

            disabled: {
                type: Boolean,
                default: false,
            },

            attributeId: {
                type: Number,
                required: true,
            },

            options: {
                type: Array,
                default: () => [],
            },

            inputPlaceholder: {
                type: String,
                default: '',
            },

            hideLabel: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                id: `attribute_dropdown_${this.attributeId}_${this._uid}`,
                localLabel: '',
                localInputPlaceholder: '',
                attributeOptionsSelected: [],
            };
        },

        computed: {
            ...mapState({
                $_meAttributeOptions: state => state.me.attributeOptions,
            }),

            ...mapGetters('site', {
                $_seekerFieldByCode: 'seekerFieldByCode',
            }),

            attributeOptions() {
                return this.$_meAttributeOptions.filter(
                    o => o.attribute_id === this.attributeId,
                );
            },
        },

        created() {
            this.cloneAttributeOptions();
            this.setLabels();
        },

        methods: {
            ...mapActions('me', {
                $_syncAttributes: 'syncAttributes',
                $_attachAttribute: 'attachAttribute',
                $_detachAttribute: 'detachAttribute',
            }),

            cloneAttributeOptions() {
                this.attributeOptionsSelected = JSON.parse(
                    JSON.stringify(this.attributeOptions),
                );
            },

            setLabels() {
                const labels = {
                    4: {
                        label: this.$t('label.industries'),
                        placeholder: this.$t('label.no_industries'),
                    },
                    5: {
                        label: this.$t('label.job_mode'),
                        placeholder: this.$t('label.no_job_mode'),
                    },
                };

                this.localLabel = labels[this.attributeId].label;
                this.localInputPlaceholder = labels[this.attributeId].placeholder;
            },

            detachAttributeOption(attributeOption) {
                const index = this.attributeOptionsSelected.findIndex(
                    o => o.id === attributeOption.id,
                );
                this.attributeOptionsSelected.splice(index, 1);

                this.syncAttributeOption();
            },

            syncAttributeOption() {
                const payload = {
                    attribute_option_ids: this.attributeOptionsSelected.flatMap(
                        o => o.id,
                    ),
                };

                this.$_syncAttributes({ id: this.attributeId, data: payload });
            },
        },
    };
</script>
